import { Button } from '../button';
import { ErrorState, type ErrorStateProps } from '../error-state';
import { FindInPageOutlinedIcon } from '../icons';

export interface PageNotFoundProps extends Pick<ErrorStateProps, 'fullscreen'> {
  onBackToHome?: () => void;
}

export default function PageNotFound(props: Readonly<PageNotFoundProps>) {
  const { onBackToHome, ...restProps } = props;

  return (
    <ErrorState
      {...restProps}
      title='ไม่พบหน้าที่คุณกำลังค้นหา'
      description='เนื่องจากลิงก์ที่ใช้ไม่ถูกต้อง กรุณาตรวจสอบลิงก์อีกครั้ง'
      action={onBackToHome ? <Button onClick={onBackToHome}>กลับหน้าหลัก</Button> : undefined}
      icon={FindInPageOutlinedIcon}
    />
  );
}
